import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { LoginComponent } from '../components/login/login.component';
import { TermsAndConditionsComponent } from '../components/terms-and-conditions/terms-and-conditions.component';
import { CommonModule } from '@angular/common';
import { LoginCoordinationService } from '../../../services/auth/login-coordination.service';

@Component({
  selector: 'app-auth-main',
  imports: [LoginComponent, CommonModule],
  templateUrl: './auth-main.component.html',
  styleUrl: './auth-main.component.css'
})
export class AuthMainComponent implements OnInit {

  //@Output() canAccessEvent = new EventEmitter<boolean>();
  isTermsOpen: boolean = false;
  canUserAccessPlatform = false;
  isTermsAccepted: boolean = false;

  constructor (private loginCoordinationService: LoginCoordinationService) { }

  ngOnInit (): void {
    //console.log("isTermsOpen?", this.isTermsOpen);
  }

  handleOpenTerms (shouldOpen: boolean) {
    this.isTermsOpen = shouldOpen;
  }

  handleTermsAccepted (value: boolean) {
    this.isTermsAccepted = value;
    this.loginCoordinationService.notifyTermsAccepted(value);
    //this.canUserAccessPlatform=value;
    //this.canAccessEvent.emit(this.canUserAccessPlatform); 
  }
}
